import { SearchCriteria } from "../../types/search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/sharp-regular-svg-icons";
import { formatDateForDisplay } from "../../utils/search";
import styles from "./search-chip.module.scss";

interface SearchChipProps {
  searchCriteria: SearchCriteria;
  onRemove: () => void;
}

export const SearchChip = ({ searchCriteria, onRemove }: SearchChipProps) => {
  const buildChipContent = () => {
    const parts: React.ReactNode[] = [];

    if (searchCriteria.patientFirstName?.trim()) {
      parts.push(
        <span key="patientFirstName">
          Patient first name contains{" "}
          <span className={styles.boldValue}>
            "{searchCriteria.patientFirstName.trim()}"
          </span>
        </span>,
      );
    }

    if (searchCriteria.patientLastName?.trim()) {
      parts.push(
        <span key="patientLastName">
          last name contains{" "}
          <span className={styles.boldValue}>
            "{searchCriteria.patientLastName.trim()}"
          </span>
        </span>,
      );
    }

    if (searchCriteria.patientDateOfBirth) {
      const formattedDate = formatDateForDisplay(
        searchCriteria.patientDateOfBirth,
      );
      if (formattedDate) {
        parts.push(
          <span key="patientDateOfBirth">
            date of birth is{" "}
            <span className={styles.boldValue}>"{formattedDate}"</span>
          </span>,
        );
      }
    }

    if (searchCriteria.patientExternalId?.trim()) {
      parts.push(
        <span key="patientExternalId">
          external ID contains{" "}
          <span className={styles.boldValue}>
            "{searchCriteria.patientExternalId.trim()}"
          </span>
        </span>,
      );
    }

    const result: React.ReactNode[] = [];

    parts.forEach((part, index) => {
      if (index === 0) {
        result.push(part);
      } else if (index === parts.length - 1) {
        result.push(" and ", part);
      } else {
        result.push(", ", part);
      }
    });

    return result;
  };

  const chipContent = buildChipContent();

  return (
    <div className={styles.chip}>
      <span className={styles.chipText}>{chipContent}</span>
      <button
        type="button"
        className={styles.removeButton}
        onClick={onRemove}
        aria-label="Clear all search filters"
      >
        <FontAwesomeIcon icon={faXmark} className={styles.removeIcon} />
      </button>
    </div>
  );
};
